import React from 'react';
import TranslationText from '../../components/Translation/TranslationText.jsx';
 
export function MethodSelector({
  isSmartIdEnabled,
  isSmartIdMethodSelected,
  onMethodChange,
  textKey
}) {
  // Don't render if Smart-ID is not enabled
  if (!isSmartIdEnabled) {
    return null;
  }
 
  const handleSmartIdSelect = () => {
    onMethodChange(true);
  };
 
  const handleEmailSelect = () => {
    onMethodChange(false);
  };
 
  return (
    <div className="form-group">
      <p>
        <TranslationText text={textKey} />
      </p>
      <div className="method-selector">
        <div className="method-tabs">
          <button
            type="button"
            className={`method-tab ${!isSmartIdMethodSelected ? 'active' : ''}`}
            onClick={handleEmailSelect}
            aria-pressed={!isSmartIdMethodSelected}
            aria-label="Select email authentication method"
          >
            <TranslationText text="email_field_label" />
          </button>
          <button
            type="button"
            className={`method-tab ${isSmartIdMethodSelected ? 'active' : ''}`}
            onClick={handleSmartIdSelect}
            aria-pressed={isSmartIdMethodSelected}
            aria-label="Select Smart-ID authentication method"
          >
            <TranslationText text="profile_information_page_smartid_label" />
          </button>          
        </div>
      </div>
    </div>
  );
} 